import { render, staticRenderFns } from "./messageComponent.vue?vue&type=template&id=24bf2c10"
import script from "./messageComponent.vue?vue&type=script&lang=js"
export * from "./messageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports